/**
 * UC-11 extension: ImplementPolicy
 */
import type { Policy } from '../../../types/policy';
import type { IAppLogger } from '../../domain/ports/IAppLogger';
import type { IPolicyManager } from '../../domain/ports/IPolicyManager';

export interface ImplementPolicyInput {
  policyId: string;
  implementer?: string;
}

export interface ImplementPolicyOutput {
  ok: boolean;
  policy?: Policy;
  error?: string;
}

export interface ImplementPolicyDependencies {
  policyManager: IPolicyManager;
  logger?: IAppLogger;
}

export class ImplementPolicyUseCase {
  constructor(private readonly deps: ImplementPolicyDependencies) {}

  execute(input: ImplementPolicyInput): ImplementPolicyOutput {
    try {
      const policy = this.deps.policyManager.implementPolicy(
        input.policyId,
        input.implementer ?? 'Player',
      );

      this.deps.logger?.log('debug', 'policy.implemented', { policyId: policy.id });

      return { ok: true, policy };
    } catch (error) {
      const message = error instanceof Error ? error.message : String(error);
      return { ok: false, error: message };
    }
  }
}